import React from "react";
import { Tooltip, Typography } from "@mui/material";

export const renderTruncatedWithTooltip = (value) => {
  if (!value) return "";
  const display = value.length > 15 ? value.substring(0, 15) + "..." : value;
  return (
    <Tooltip title={value}>
      <Typography variant="body2">{display}</Typography>
    </Tooltip>
  );
};
